import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, RippleModule],
  template: `
    <div class="flex h-full w-full flex-col items-center justify-center gap-6 p-8 text-center">
      <h2
        class="font-bold title_custom bg-gradient-to-br from-gray-400 via-gray-200 to-gray-400 bg-clip-text text-transparent"
      >
        404
      </h2>
      <div class="flex flex-col gap-2">
        <h2 class="text-2xl font-semibold text-gray-800">Page Not Found</h2>
        <p class="text-gray-600 max-w-md">The page you are looking for does not exist.</p>
      </div>
      <p-button  (click)="goHome()">
        Go Home
      </p-button>
    </div>
  `,
  styles: `
    .title_custom{
      font-size: 128px;
      line-height:1;
      /* Required for animation */
      background-size: 300% 300%;
      animation: gradient-move 4s ease-in-out infinite;
    }

    @keyframes gradient-move {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `
})
export class NotFoundPage {
  private router = inject(Router);
  goHome() {
    this.router.navigate(['/']);
  }
}
